import { useSyncExternalStore } from "react";

// Service worker registration (#42). A new deploy installs a new worker that waits; the app
// shows "Nueva versión disponible · Actualizar" and only reloads when you tap it.

let needRefresh = false;
let update: (() => Promise<void>) | null = null;
const listeners = new Set<() => void>();

/** Checks for a new deploy this often while the app stays open. */
const CHECK_EVERY_MS = 60 * 60 * 1000;

export function registerServiceWorker(): void {
  // dev and tests have no worker: Vite serves the modules directly
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  void import("virtual:pwa-register").then(({ registerSW }) => {
    update = registerSW({
      onNeedRefresh() {
        needRefresh = true;
        listeners.forEach((l) => l());
      },
      onRegisteredSW(_url, registration) {
        if (registration) setInterval(() => void registration.update(), CHECK_EVERY_MS);
      },
    });
  });
}

/** Whether a new version is waiting for the user to tap Actualizar. */
export function useUpdateAvailable(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => needRefresh,
  );
}

/** Switch to the waiting version and reload the page. */
export function applyUpdate(): void {
  // reload once the new worker is in charge (the plugin only does it when the page started
  // under an older worker, not on the visit that installed the first one)
  navigator.serviceWorker.addEventListener("controllerchange", () => window.location.reload(), {
    once: true,
  });
  void update?.();
}
